var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[(_vm.isLoading)?_c('loading-spinner'):_c('paginated-table',{attrs:{"data":_vm.announcements,"columns":_vm.tableColumns,"title":_vm.$t('title.announcement_list')},on:{"updatePagination":_vm.updatePagination}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }